export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";